import { Avatar } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import React, { useEffect, useRef } from "react";
import typingAnimation from "./assets/typing-animation.json";
import { ChatBotPreviewTheme } from "../../consts";

interface ChatBotPreviewTypingBubbleProps {
  username: string;
  avatarUrl: string;
  theme: ChatBotPreviewTheme;
}

export const ChatBotPreviewTypingBubble: React.FC<
  ChatBotPreviewTypingBubbleProps
> = ({ username, avatarUrl, theme }) => {
  const ref = useRef<HTMLDivElement>(null);

  // Scroll the the bubble on mount
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div ref={ref} className="flex items-end gap-1">
      <Avatar username={username} size="sm" imageUrl={avatarUrl} />
      <div
        className={cx(
          "mt-6 flex w-max flex-col gap-[5px] rounded-2xl rounded-bl-none p-4",
          theme.incomingBg
        )}
      >
        <span className="font-secondary text-sm leading-[140%] font-medium text-dark-600">
          {username}
        </span>
        <Lottie
          className="justify-start"
          options={{ animationData: typingAnimation }}
          height={32}
          width={26}
        />
      </div>
    </div>
  );
};
